/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Badge_NoneInputs */

const vi_einvoice_badge_none = /** @type {(inputs: Einvoice_Badge_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không yêu cầu hóa đơn`)
};

/**

* @param {Einvoice_Badge_NoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_badge_none = /** @type {((inputs?: Einvoice_Badge_NoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Badge_NoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_badge_none(inputs)
});